export const IconSettingsFilled = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M9.094 3.53c-.182.547-.598.977-1.102 1.257a8 8 0 0 0-.232.135c-.495.297-1.076.442-1.641.327l-1.202-.246a2 2 0 0 0-2.133.96l-.62 1.075a2 2 0 0 0 .235 2.327l.815.919c.382.43.547 1.005.538 1.58q-.003.135 0 .271c.009.576-.156 1.15-.538 1.581l-.815.92a2 2 0 0 0-.236 2.326l.621 1.076a2 2 0 0 0 2.133.96l1.202-.247c.565-.115 1.146.03 1.64.327q.116.069.233.135c.504.28.92.71 1.102 1.257l.388 1.163A2 2 0 0 0 11.379 23h1.242a2 2 0 0 0 1.897-1.367l.388-1.163c.182-.547.598-.977 1.102-1.257a8 8 0 0 0 .232-.135c.495-.297 1.076-.442 1.641-.327l1.202.246a2 2 0 0 0 2.133-.96l.62-1.075a2 2 0 0 0-.235-2.327l-.815-.919c-.382-.43-.547-1.005-.538-1.58q.003-.135 0-.272c-.009-.575.156-1.15.538-1.58l.815-.92a2 2 0 0 0 .236-2.326l-.621-1.076a2 2 0 0 0-2.133-.96l-1.202.247c-.565.115-1.146-.03-1.64-.327a8 8 0 0 0-.233-.135c-.504-.28-.92-.71-1.102-1.257l-.388-1.162A2 2 0 0 0 12.621 1h-1.242a2 2 0 0 0-1.897 1.368zM15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
        clipRule="evenodd"
      />
    </svg>
  );
};
